import React, { useState, useEffect, ReactNode, FC } from 'react';
import { Tooltip } from 'antd';

interface AutoCloseTooltipProps {
  title: ReactNode;
  children: ReactNode;
  duration?: number; // milliseconds (default: 5000)
}

const AutoCloseTooltip: FC<AutoCloseTooltipProps> = ({ title, children, duration = 4000 }) => {
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    if (open) {
      timer = setTimeout(() => setOpen(false), duration);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [open, duration]);

  return (
    <Tooltip
      title={title}
      open={open}
      onOpenChange={(visible: boolean) => setOpen(visible)}
      rootClassName="antd-movement-insights"
    >
      <span onMouseEnter={() => setOpen(true)} style={{ display: 'inline-block' }}>
        {children}{' '}
      </span>
    </Tooltip>
  );
};

export default AutoCloseTooltip;
